import { makeStyles } from '@/styles/theme/tss-react';
import { darkOrLightStyle } from '@/utils/styles';

const useStyles = makeStyles<{ isOnDark?: boolean }>({
  name: 'ProductPageBase',
})(
  (
    { spacing, breakpoints, brandColors, typography: { pxToRem }, type },
    props
  ) => ({
    container: {
      backgroundColor: darkOrLightStyle(props)(
        brandColors.tintsHeroBlue10,
        brandColors.tintsOffWhite60
      ),
    },
    body: {
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginTop: spacing(3),
      gap: 0,
      [breakpoints.up('md')]: {
        gap: pxToRem(40),
        flexDirection: 'row',
      },
      [breakpoints.up('lg')]: {
        gap: pxToRem(80),
      },
    },
    carouselContainer: {
      minWidth: 0,
      flex: 1,
    },
    productInformationContainer: {
      marginTop: pxToRem(24),
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: spacing(2),
      [breakpoints.up('sm')]: {
        marginTop: 0,
      },
    },
    heading: {
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    },
    subheading: {
      color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
      marginTop: spacing(0),
    },
    disclaimerSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
      width: '100%',
    },
    disclaimerLabel: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: pxToRem(8),
      width: '100%',
    },
    disclaimerCheckbox: {
      flexShrink: 0,
      marginTop: pxToRem(2),
    },
    disclaimer: {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
      flex: 1,
      minWidth: 0,
      margin: 0,
      ...type['12_regular'],
      [breakpoints.up('sm')]: {
        ...type['14_regular'],
      },
      [breakpoints.up('lg')]: {
        ...type['16_regular'],
      },
    },
    disclaimerCheckboxTerms: {
      '& p:first-of-type': {
        marginTop: 0,
      },
      '& p, li': {
        color: darkOrLightStyle(props)(
          brandColors.tintsOffWhite40,
          brandColors.tintsNeutral20,
          true
        ),
        fontSize: `${type['12_regular'].fontSize}!important`,
        fontWeight: `${type['12_regular'].fontWeight}!important`,
        lineHeight: `${type['12_regular'].lineHeight}!important`,
        letterSpacing: `${type['12_regular'].letterSpacing}!important`,
      },
      '& p a': {
        color: darkOrLightStyle(props)(
          brandColors.chargeBlue,
          brandColors.mediumBlue,
          true
        ),
      },
      '& p a:hover': {
        color: darkOrLightStyle(props)(
          brandColors.white,
          brandColors.primaryMain,
          true
        ),
      },
      [breakpoints.up('sm')]: {
        '& p, li': {
          fontSize: `${type['14_regular'].fontSize}!important`,
          fontWeight: `${type['14_regular'].fontWeight}!important`,
          lineHeight: `${type['14_regular'].lineHeight}!important`,
          letterSpacing: `${type['14_regular'].letterSpacing}!important`,
        },
      },
      [breakpoints.up('lg')]: {
        '& p, li': {
          fontSize: `${type['16_regular'].fontSize}!important`,
          fontWeight: `${type['16_regular'].fontWeight}!important`,
          lineHeight: `${type['16_regular'].lineHeight}!important`,
          letterSpacing: `${type['16_regular'].letterSpacing}!important`,
        },
      },
    },
    checkoutButtons: {
      display: 'flex',
      width: '100%',
      gap: spacing(1),
    },
  })
);

export default useStyles;
